/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/3fa5e1a4a30020dd5e697449d7063e91.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/f75baae09e824318a2293cf1a6672053.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/433e5708f4c891258d974a46ee173014.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/6878cc155d476b75c3885c9ca98cc606.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/726e3ae1dc29fa208d08db3499ed29f6.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/58f215d09e73029e8456bd60934e78b3.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/4ac114fb7746a8cc4dcdd2f301aa8cf9.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/7ae062ddcd72530cdc18d6655a9c8523.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/bd7fde9f118e6529afe331ba7db55271.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/51a684c06a56128825e77e4a67df96fd.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/37302b09a4312abc0bc49d5003b96bc5.png",

    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/ce1d23bb6be7ef51ab0d184809dd044e.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/1319884d0bf652342d310b7352d239ae.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/71e671b46544d3d72e6a297023aba111.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/61ca30375998048dfcb09b4cd4ec7f3f.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/c547d2fb203d8e6160560856a69ca2a4.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/52cc905b2f9ea6dd256e24158155206e.png",
    "https://cdn.shopify.com/s/files/1/0696/1096/3161/files/2f12587e546a58ca2b0bb8daf8848e34.png",
  ];

  new Swiper(".sp-swiper-btn", {
    spaceBetween: 10,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 4000,
    },
  });
  new Swiper(".sp-swiper1", {
    spaceBetween: 10,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".sp-pagination1",
      type: "bullets",
      clickable: true,
    },
  });
  new Swiper(".sp-swiper2", {
    spaceBetween: 30,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    centeredSlides: true,
  });

  let _swiper = new Swiper(".sp-swiper-p1", {
    spaceBetween: 10,
    speed: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height() +
          $(".sp-nav").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

        var links2 = document.querySelectorAll('a[href^="#add-cart"]');
    links2.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('revue-product-compo');
        // console.log(targetElement)
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.querySelector("#add-cart"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // 找到所有跳转套餐的锚点链接
    
    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 19.99;
  let sp_price2 = 39.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  let prods = window.product
    console.log(prods,'prods')
      function getCur(){
        let color = $('#sp-color div.active').attr('data-val')
        // let type = $('#sp-type div.active').attr('data-val')
        // return prods.filter(item=> item.option1 == color && item.option2 == type)[0]
        return prods.filter(item=> item.option1 == color)[0]
      }
      function changePrice(){
        let num = $('#calcNumber').val()
        let price = (getCur().price * num / 100).toFixed(2)
        let compare = (getCur().compare_at_price * num / 100).toFixed(2)
        price = (price + '').replace('.', ',')
        compare = (compare + '').replace('.', ',')
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
        $(".product-part .price-group .sp-row span").html(`${off_font}`)
      }
   $('.sp-btn-style').click(function(){
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
        // $.post('/api/checkout/order', {
        //     line_items: [{
        //         quantity: num, // 数量
        //         variant_id: getCur().id, // 子商品id
        //         note: '', // 备注
        //     }],
        //     refer_info: { source: 'buy_now' }
        //     }, function (ret) {
        //     if (ret.state === 'success') {
        //         return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
        //     } else {
        //         $.toast.show({
        //         content:
        //             {
        //             '30003': "Some items have been removed, please re-order",
        //             'line_items_variant_withdraw': "Some items have been sold out, please re-order",
        //             'line_items_variant_sold_out': "Some items are not in stock, please re-order"
        //             }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
        //         });
        //     }
        // });
    })

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });
  let _sptext = [
    "Ferme heureuse",
    "Océan mystérieux",
    "Paradis des oiseaux",
    "Animaux sauvages",
    ` Forfait A
                  <span class="sp-span"
                    >(Ferme heureuse + Océan mystérieux + Paradis des oiseaux + Faune sauvage)</span
                  >`,
    "Insectes",
    "Jardins",
    "Dinosaures",
    "Zoos",
    `Ensemble B
                <span class="sp-span">(Insectes + Jardins + Dinosaures + Zoos)</span>`,

    `Ensemble A+ Ensemble B<span class="sp-span">(8 livres)-</span
                ><span class="sp-span2">Livraison gratuite</span>`,
  ];
  let _sptext2 =[
    "Pop-up book only",
    "Pop-up book + Marker Pen"
  ]
  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $("#sp-color .sp-option.active").index();
    // let typeOptions = $("#sp-type .sp-option.active").index();

    // _index = colorOptions + typeOptions*11;
    $(".sp-color .sp-choose").html(_sptext[colorOptions]);
    // $(".sp-type .sp-choose").html(_sptext2[typeOptions]);
    _swiper.slideToLoop(colorOptions);
    changePrice()
  });

  $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
        let data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
          })
        },
        dataType: 'json',
      })
      
    //   $.post(
    //     "/api/cart",
    //     { 
    //         product_id: getCur().product_id,
    //         variant_id: getCur().id,
    //         quantity: $('#calcNumber').val(),
    //     },
    //     function(res){
    //         $.get("/api/cart",function(res){
    //             $("#cardNum").html(res.cart.item_count);
    //         })
    //     }
    //     )
      $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);

      var imgs = $(".product-part .swiper-slide-active").find("img");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",

          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish = $(".sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop + $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });
});
